import { Common, color } from '@stockbit/ui';
import { func } from 'prop-types';
import { CloseIconWrapper } from './styled';

const { Iconmoon } = Common;

type propTypes = {
  onClick: (e: MouseEvent) => void;
};

const CloseIcon = ({ onClick }: propTypes) => (
  <CloseIconWrapper onClick={onClick}>
    <Iconmoon
      className="icon-widget_close"
      color={color.light}
      hoverColor={color.light}
      size="10px"
      weight="bold"
    />
  </CloseIconWrapper>
);

CloseIcon.propTypes = {
  onClick: func,
};

CloseIcon.defaultProps = {
  onClick: () => {},
};

export default CloseIcon;
